import { bulkAction, closeDialog, openOverwriteModal, } from '@innovyze/stylovyze/lib/actions/curveManager.actions';
import useYupSchemaValidation from '@innovyze/stylovyze/lib/hooks/useYupSchemaValidation';
import CurveManagerDialogForm from '../CurveManagerDialogForm';
import { StylovyzeComposableDialog } from '@innovyze/stylovyze/lib/components';
import { useSelectCurveManager } from '../../../selectors';
import { useGlobalization } from '../../../contexts';
import { curveDataSchema, CurveManagerDialogs, CurveOperationType, } from '../../../types/curveManager.types';
import { useIsFeatureEnabled } from '../../../utils';
import { CURVE_TABLE_HEADERS } from '@innovyze/stylovyze/lib/utils/curveManagerUtils';
import { useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import CurveManagerDrawerTable from '../CurveManagerDrawer/CurveManagerDrawerTable';
import CurveManagerFileDropzone from '../CurveManagerDrawer/CurveManagerFileDropzone';
import DrawerFooter from '../Drawer/DrawerFooter';
import { DropzoneTable, DropzoneTableContainer, } from './CreateOrEditCurveDialog.styles';
import React from 'react';
const CreateOrEditCurveDialog = () => {
    const { t } = useGlobalization();
    const dispatch = useDispatch();
    const isCurveUnitsEnabled = useIsFeatureEnabled('info-360-analytics-manufacture-curve-units');
    const { curveById, dialog, overwriteModal } = useSelectCurveManager();
    const [validate] = useYupSchemaValidation();
    const formikProps = useFormikContext();
    const [dialogTitle, setDialogTitle] = useState('');
    const [footButtonText, setFootButtonText] = useState('');
    const handleFormCancel = () => {
        dispatch(closeDialog());
        formikProps.resetForm();
    };
    useEffect(() => {
        if (overwriteModal.initialized) {
            if (dialog === CurveManagerDialogs.CreateCurve) {
                if (overwriteModal.curveById) {
                    dispatch(openOverwriteModal(overwriteModal.curveById.assetType));
                }
                else {
                    formikProps.setSubmitting(true);
                    const validationResults = validate(formikProps.values, curveDataSchema);
                    formikProps.setErrors(validationResults.errors);
                    if (validationResults.hasErrors) {
                        formikProps.setSubmitting(false);
                        return;
                    }
                    const curveOperationData = {
                        type: formikProps.values.curveType,
                        body: {
                            name: formikProps.values.curveName,
                            depthArray: formikProps.values.curveData.depthArray,
                            volumeArray: formikProps.values.curveData.volumeArray,
                            xSeries: isCurveUnitsEnabled
                                ? formikProps.values.curveData.xSeries
                                : undefined,
                            ySeries: isCurveUnitsEnabled
                                ? formikProps.values.curveData.ySeries
                                : undefined,
                        },
                    };
                    dispatch(bulkAction([
                        {
                            operation: CurveOperationType.CREATE,
                            data: curveOperationData,
                        },
                    ]));
                    dispatch(closeDialog());
                }
            }
            else if (dialog === CurveManagerDialogs.EditCurve) {
                const curveOperationData = {
                    type: curveById.curve?.oldAssetType ??
                        formikProps.values.curveType,
                    body: {
                        ...curveById.curve,
                        xSeries: isCurveUnitsEnabled
                            ? formikProps.values.curveData.xSeries
                            : undefined,
                        ySeries: isCurveUnitsEnabled
                            ? formikProps.values.curveData.ySeries
                            : undefined,
                    },
                };
                dispatch(bulkAction([
                    {
                        operation: CurveOperationType.UPDATE,
                        data: curveOperationData,
                    },
                ]));
                dispatch(closeDialog());
            }
        }
    }, [overwriteModal.curveById, overwriteModal.initialized]);
    useEffect(() => {
        if (!dialog) {
            formikProps.resetForm();
        }
        else if (dialog === CurveManagerDialogs.EditCurve) {
            formikProps.setFieldValue('curveName', curveById.curve?.name);
            formikProps.setFieldValue('curveType', curveById.curve?.assetType);
            formikProps.setFieldValue('curveData.xSeries', curveById.curve?.xSeries);
            formikProps.setFieldValue('curveData.ySeries', curveById.curve?.ySeries);
            formikProps.setFieldValue('curveData.depthArray', curveById.curve?.depthArray);
            formikProps.setFieldValue('curveData.volumeArray', curveById.curve?.volumeArray);
            setDialogTitle(t('Edit Curve'));
            setFootButtonText(t('Update'));
        }
        else {
            setDialogTitle(t('Create New Curves'));
            setFootButtonText(t('Create'));
        }
    }, [dialog]);
    const handleSubmit = async () => {
        await formikProps.submitForm();
    };
    return (React.createElement(StylovyzeComposableDialog, { title: dialogTitle, open: !!dialog, onCancel: () => {
            // do nothing.
        }, footer: React.createElement(DrawerFooter, { onCancelClick: handleFormCancel, action: {
                title: footButtonText,
                onClick: () => void handleSubmit(),
                enabled: !!formikProps.values.curveData.depthArray?.length,
            } }) },
        React.createElement(CurveManagerDialogForm, { formikProps: formikProps }),
        React.createElement(DropzoneTableContainer, null, formikProps.values.curveData.depthArray.length > 0 ? (React.createElement(DropzoneTable, null,
            React.createElement(CurveManagerDrawerTable, { dataCy: 'curves-table', headers: CURVE_TABLE_HEADERS(t) }))) : (React.createElement(CurveManagerFileDropzone, null)))));
};
export default CreateOrEditCurveDialog;
